const bank = process.env.BANK

const componentConfig = {
  newsHomePopups: {
    terminalActivation: {
      isVisible: () => ['NEXIBUSINESS'].includes(bank)
    }
  }
}

export default componentConfig
